import { Box, Bleed, Stack } from 'braid-design-system';
import React, { type ReactNode, useId } from 'react';

import * as styles from './CustomRadioButton.css';

interface CustomRadioButtonProps {
  selected: boolean;
  onChange: () => void;
  label: ReactNode;
  description: ReactNode;
}

export const CustomRadioButton = (props: CustomRadioButtonProps) => {
  const id = useId();

  return (
    <Box className={styles.container}>
      <Bleed top="xxsmall">
        <Box
          id={id}
          component="button"
          onClick={() => props.onChange()}
          tabIndex={0}
          className={[
            styles.radioButtonContainer,
            props.selected && styles.radioButtonContainerSelected,
          ]}
        >
          <Box className={styles.radioButton}>
            <Box className={styles.radioButtonInner} />
          </Box>
          <Box className={styles.radioButtonFocused} />
        </Box>
      </Bleed>

      <Stack space="small">
        <Box component="label" htmlFor={id} cursor="pointer" userSelect="none">
          {props.label}
        </Box>
        <Box>{props.description}</Box>
      </Stack>
    </Box>
  );
};
